export const CM_CONTRACT_START = 'CM_CONTRACT_START';
export const CM_CONTRACT_END = 'CM_CONTRACT_END';
export const CM_CONTRACT_BY_ID = 'CM_CONTRACT_BY_ID';
export const CM_CONTRACT_RESET = 'CM_CONTRACT_RESET';
